import {Directive} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator, Validators} from '@angular/forms';

@Directive({
  selector: '[appNumbersOnly]',
  providers: [{provide: NG_VALIDATORS, useExisting: NumbersOnlyDirective, multi: true}]
})
export class NumbersOnlyDirective implements Validator {

  private reggy = new RegExp(/([a-z]|[A-Z]|[$&+,:;=?@#|'<>.^*()%!\-])+/);

  constructor() {
  }

  validate(control: AbstractControl): { [key: string]: any } {
    const rslt = Validators.pattern(this.reggy)(control);

    return rslt ? null : {'numbersOnly': true};
  }
}
